// Create: /pages/CreateAdminPage.jsx  
import React from 'react';
import { CreateAdminPage } from '../components/Auth-Designer';

const CreateAdminPageWrapper = () => {
  return <CreateAdminPage />;
};

export default CreateAdminPageWrapper;